import { Tab } from "@headlessui/react";
import { PencilAltIcon } from "@heroicons/react/outline";
import React, { FC, Fragment, useState, useEffect, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Route, Redirect, useHistory, Link, useParams, useLocation } from 'react-router-dom';
import visaPng from "images/vis.png";
import mastercardPng from "images/mastercard.svg";
import Input from "shared/Input/Input";
import Label from "components/Label/Label";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import StartRating from "components/StartRating/StartRating";
import NcModal from "shared/NcModal/NcModal";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import CheckoutForm, { CheckOutFormRef } from "./CheckoutForm";
import { DateRage } from "components/HeroSearchForm/StaySearchForm";
import axios from 'axios';
import GuestsInput from "components/HeroSearchForm/GuestsInput";
import { Helmet } from "react-helmet";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Checkbox from "shared/Checkbox/Checkbox";
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input';
import SectionCouponSlider from "components/SectionCounpnSlider/SectionCounpnSlider";
import { CouponDataTaxonomy } from "data/types";
import CommonPaymentFields from "./CommonPaymentFields"; // Import the component
import PaymentDropdown from "./PaymentMethodDropdown";
import { useAuth } from "hooks/useAuth"; // Adjust path if needed
export interface CheckOutPageProps {
  className?: string;
  clientSecret?: string;
  autoFocus?: boolean;
}
const CheckOutPage: FC<CheckOutPageProps> = ({
  className = "",
  autoFocus = false,
}) => {
  const appearance = {
    theme: 'stripe',
  };
  const [clientSecret, setClientSecret] = useState("");
  const [selectedDate, setSelectedDate] = useState<DateRage>({
    /*startDate: moment(),
    endDate: moment().add(1, "days"),*/
    startDate: null,
    endDate: null,
  });
  let search = window.location.search;
  const history = useHistory();
  const [guestyListingId, setguestyListingId] = useState(new URLSearchParams(search).get('listing'));
  const [checkin, setCheckin] = useState(new URLSearchParams(search).get('checkin'))
  const [checkout, setCheckout] = useState(new URLSearchParams(search).get('checkout'))
  const [adults, setAdults] = useState(new URLSearchParams(search).get('adult') ? new URLSearchParams(search).get('adult') : 0);
  const [children, setChildren] = useState(new URLSearchParams(search).get('children') ? new URLSearchParams(search).get('children') : 0);
  const [infants, setInfants] = useState(new URLSearchParams(search).get('infants'));
  const [isInvalidBooking, setIsInvalidBooking] = useState(false);
  const [isdataLoaded, setIsdataLoaded] = useState(false);
  const [priceBreakDown, setPriceBreakDown] = useState("");
  const [listingName, setListingName] = useState("");
  const [reviewCount, setReviewCount] = useState(0);
  const [reviewRating, setReviewRating] = useState(0);
  const [listingImg, setListingImg] = useState("");
  const [beds, setBeds] = useState(0);
  const [bathrooms, setBathrooms] = useState(0);
  const [totalGuest, setTotalGuest] = useState(0);
  const [totalPaymentPrice, setTotalPaymentPrice] = useState(0);
  const [serviceFee, setServiceFee] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [currency_code, setCurrency_code] = useState("");
  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [orderId, setOrderId] = useState(false);
  const [authenticated, setauthenticated] = useState(null);
  const [user_id, setUserId] = useState("");
  const [bookingRef, setBookingRef] = useState("");
  const [paypalClientid, setPaypalClientid] = useState("");
  const [stripeClientid, setStripeClientid] = useState("");
  const [paypalCurrency, setPaypalCurrency] = useState("");
  const [paypalTotalPrice, setPaypalTotalPrice] = useState(0);
  const [isOpenModalCoupon, setIsOpenModalCoupon] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [detailsCoupon, setDetailsCoupon] = useState({
    coupon_code: localStorage.getItem("appliedCoupon") || "",
  });
  const CouponRef = useRef<HTMLInputElement>(null);
  const [showPopover, setShowPopover] = useState(autoFocus);
  const [isDicountApplied, setIsDicountApplied] = useState(false);
  const [isGiftCard, setIsGiftCard] = useState(false);
  const [isMerchantsAllow, setIsMerchantsAllow] = useState(true);
  const [isCartProceed, setisCartProceed] = useState(false);
  const [appliedCode, setAppliedCode] = useState(new URLSearchParams(search).get('coupon_code'));
  const [processing, setProcessing] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [guestDetailsRequired, setGuestDetailsRequired] = useState(false);
  const [details, setDetails] = useState({ email: "", phone: "" });
  let searchParams = new URLSearchParams(search);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  const [emailMandatory, setEmailMandatory] = useState(false);
  const [phoneMandatory, setPhoneMandatory] = useState(false);
  const [value, setValue] = useState("");
  const [cartDetails, setCartDetails] = useState([]);
  const [grandTotalAmtDisplay, setgrandTotalAmtDisplay] = useState({
    displayGrandTototal: "",
    subtotal: "",
    display_additonal_guest_price: Number,
    totalCleaning: "",
    totalService: "",
    totalTaxes: "",
    discountamout: "",
    giftcardAmount: "",
    price_prefix: "",
    service_fee_percentage:"",
    tax_rate_percentage:"",
  });
  const [grandTotalAmt, setGrandTotalAmt] = useState(0);
  const [cartIDS, setCartIDS] = useState([]);
  const [grandTotalBD, setGrandTotalBD] = useState("");
  const [bookingSource, setBookingSource] = useState("");
  const [addmorelink, setAddmorelink] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("STRIPE");
  const [appliedGift, setAppliedGift] = useState<string | null>(localStorage.getItem("appliedGift"));
  const [appliedCoupon, setAppliedCoupon] = useState<string | null>(localStorage.getItem("appliedCoupon"));
  const [coupons, setCoupons] = useState<CouponDataTaxonomy[]>([]);
  const [totalPromoCount, setTotalPromoCount] = useState(Number);

  const [appliedGiftCard, setAppliedGiftCard] = useState<string | null>(localStorage.getItem("appliedGiftCard"));
  const [giftCards, setGiftCards] = useState<CouponDataTaxonomy[]>([]);
  const [totalGiftCount, setTotalGiftCount] = useState(Number);

  const [activeTab, setActiveTab] = useState<"discount" | "gift">("gift");
  const [appliedCouponError, setAppliedCouponError] = useState("");
  const [paymentmessage, setPaymentmessage] = useState("");
  const [listingCountry, setListingCountry] = useState("");
  const [cancellationPolicyText, setCancellationPolicyText] = useState("");
  const checkOutFormRef = useRef<CheckOutFormRef>(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isButtonProccessing, setIsButtonProccessing] = useState(false);
  const [isButtonSucceed, setIsButtonSucceed] = useState(false);
  const [phone, setPhone] = useState("");
  const [paymentError, setPaymentError] = useState<string | null>(null);
  const [availablePaymentMethod, setAvailablePaymentMethod] = useState(["STRIPE","PAYPAL"]);


  const { user } = useAuth();

  const DeleteCart = (id: any) => {
    console.log(id);
    axios.post(process.env.REACT_APP_BASE_URL + 'DeleteCart', {
      user_id: user?.user_id,
      cart_id: id
    }
    ).then(res => {
      if (res.data.status == 401) {
        //setCalendarMessage(res.data.response);
      }
      if (res.data.status == 200) {
        history.push("/checkout");
        history.go(0);
      }
    });
  }

  const randomString = (length: any) => {
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
    return result;
  }
  let stripePromise: any;

  useEffect(() => {
    if (cartIDS.length > 0) {
      axios.get(process.env.REACT_APP_BASE_URL + 'check_validate_guest_details?user_id=' + user?.user_id)
        .then(res => {
          console.log(res.data.status);
          if (res.data.status == true) {
            setGuestDetailsRequired(res.data.response_data.response_code);
            if (res.data.response_data.response_type == '1') {
              setEmailMandatory(true);
            }
            if (res.data.response_data.response_type == '2') {
              setPhoneMandatory(true);
            }
            if (res.data.response_data.response_type == '3') {
              setEmailMandatory(true);
              setPhoneMandatory(true);
            }
          } else {
            setGuestDetailsRequired(res.data.response_data.response_code);
          }
        })
    }
  }, [cartIDS, appliedCode, isMerchantsAllow]);

  const options = {
    clientSecret
  };
  useEffect(() => {
    axios.get(process.env.REACT_APP_BASE_URL + "getCartDetails", {
      params: {
        user_id: user?.user_id,
        discountcode: appliedCoupon,
        giftCardCode: appliedGift
      }
    })
      .then(res => {
        setIsdataLoaded(true);
        if (res.data.success == true) {
          setIsdataLoaded(true);
          setCartDetails(res.data.cart_details);
          setIsInvalidBooking(true);
          setPaypalClientid(res.data.merchant_info.paypal_client_id);
          setStripeClientid(res.data.merchant_info.stripe_client_id);
          setAvailablePaymentMethod(res.data.merchant_info.availablePaymentMethods);
          setGrandTotalAmt(res.data.price_details.payment_price.grandTotal);
          setgrandTotalAmtDisplay({
            displayGrandTototal: res.data.price_details.display_price.grandTotal,
            subtotal: res.data.price_details.display_price.subtotal,
            display_additonal_guest_price: res.data.price_details.display_price.display_additonal_guest_price,
            totalCleaning: res.data.price_details.display_price.totalCleaning,
            totalService: res.data.price_details.display_price.totalService,
            totalTaxes: res.data.price_details.display_price.totalTaxes,
            discountamout: res.data.price_details.display_price.discount_price,
            giftcardAmount: res.data.price_details.display_price.gift_discounted_price,
            price_prefix: res.data.price_details.display_price.price_prefix,
            service_fee_percentage:res.data.price_details.display_price.service_fee_percentage,
            tax_rate_percentage:res.data.price_details.display_price.tax_rate_percentage,
          });
          setPaypalCurrency(res.data.currency_code);
          setPaypalTotalPrice(res.data.price_details.payment_price.grandTotal);
          setCartIDS(res.data.cart_ids);
          setGrandTotalBD(res.data.price_details.display_price.display_price_html);
          setIsDicountApplied(res.data.is_discount_applied);
          setIsMerchantsAllow(res.data.isMerchantsAllow);
          setisCartProceed(res.data.isCartProceed);
          setBookingSource(res.data.bookingSource);
          setAddmorelink(res.data.addmorelink);
          setListingCountry(res.data.country_id);
          setCancellationPolicyText(res.data.one_week_before);
          //setPaypalCurrency(res.data.booking_price_details.paypal_price.currency_code);
          //setPaypalTotalPrice(res.data.booking_price_details.paypal_price.total_price);
        }
      });

  }, [appliedCoupon, appliedGift, bookingSource]);
  if (stripeClientid != '') {
    stripePromise = loadStripe(stripeClientid);
  }
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    if (paypalTotalPrice > 0 && bookingSource!='') {
      var BookingRerence_Number = randomString(10);
      axios.post(process.env.REACT_APP_BASE_URL + "stripe_signature_v1", {
        items: [{
          amount: paypalTotalPrice,
          cart_ids: cartIDS,
          bookingRefNo: BookingRerence_Number,
          user_id: user?.user_id,
          bookingSource: bookingSource,
          discount_code: (appliedCoupon != null ? appliedCoupon : ''),
          giftcard_code: (appliedGift != null ? appliedGift : ''),
        }]
      })
        .then(function (response) {
          setClientSecret(response.data.clientSecret);
          setBookingRef(BookingRerence_Number)
        });
    }
  }, [cartIDS,paypalTotalPrice,paymentMethod,bookingSource]);

  const handlePaymentSuccess = (paymentData: any) => {
    ///console.log("Payment successful! Booking data:", paymentData);
    axios.post(process.env.REACT_APP_BASE_URL + "createStripeBooking", paymentData)
      .then((response) => {
        if (response.data.success) {
          ///console.log("Booking created successfully:", response.data);
          // Redirect to confirmation page
          localStorage.removeItem("appliedCoupon");
          localStorage.removeItem("manuallyAppliedPromoCoupons");
          localStorage.removeItem("appliedGift");
          localStorage.removeItem("manuallyAppliedGiftCoupons");
          history.push(`/pay-done/${paymentData.bookingRef}`);
          history.go(0);
        } else {
          console.error("Booking creation failed:", response.data.message);
        }
      })
      .catch((error) => console.error("Error creating booking:", error));
  };

  const createOrder = async () => {
    try {
      let BookingRerence_Number = randomString(10);
      axios.post(process.env.REACT_APP_BASE_URL + "createPaypalOrder", {
        items: [{
          amount: paypalTotalPrice,
          cart_ids: cartIDS,
          bookingRefNo: BookingRerence_Number,
          user_id: user?.user_id,
          bookingSource: bookingSource,
          discount_code: (appliedCoupon != null ? appliedCoupon : ''),
          giftcard_code: (appliedGift != null ? appliedGift : ''),
          guest_message:paymentmessage
        }]
      })
        .then(function (response) {
          if (response.data.success) {
            setOrderId(response.data.orderID);
            if (response.data.orderID && response.data.orderID) {
              const width = 600;
              const height = 700;
              const left = (window.innerWidth - width) / 2;
              const top = (window.innerHeight - height) / 2;
              const popup = window.open(response.data.payment_approval_url,
                "PayPal Payment",
                `width=${width},height=${height},top=${top},left=${left}`
              );
            }
            const receiveMessage = (event:any) => {
              if (!event.data) {
                  //console.warn("⚠️ Received empty event data");
                  return;
              }
              // ✅ Ensure event data is parsed correctly
              try {
                  const paymentData = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
                  ///alert("Payment Received! Order ID: " + paymentData.order_id);
                  if (paymentData.success) {
                    console.log("✅ Payment Data Received:", paymentData);
                    localStorage.removeItem("appliedCoupon");
                    localStorage.removeItem("manuallyAppliedPromoCoupons");
                    localStorage.removeItem("appliedGift");
                    localStorage.removeItem("manuallyAppliedGiftCoupons");
                    history.push(`/pay-done/${paymentData.order_id}`);
                    history.go(0);
                      //console.log("✅ Payment Successful:", paymentData.transaction_id);
                  } else {
                      //console.error("❌ Payment Failed:", paymentData.message);
                  }
              } catch (error) {
                  //console.error("❌ Error parsing event data:", error);
              }
          };
          
          // ✅ Attach Listener
          window.addEventListener("message", receiveMessage);

            /*const paypalUrl = response.data.payment_approval_url;
            const datadd = window.open(paypalUrl, "paypalPopup", "width=500,height=700");
            const popup = window.open("",
              "PayPal Payment",
              "width=600,height=700"
            );*/
          }
        });
      /*const response = await fetch("/createPaypalOrder", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount: "10.00", currency: "USD" }),
      });

      const data = await response.json();
      setOrderId(data.orderID);*/
    } catch (err) {
      setErrorMsg("Error creating order");
    }
  };

  const captureOrder = async () => {
    if (!orderId) return;
    try {
      const response = await fetch(`/capturePaypalOrder/${orderId}`, {
        method: "POST",
      });

      const data = await response.json();
      if (data.status === "COMPLETED") {
        alert("Payment Successful!");
      } else {
        setErrorMsg("Payment failed");
      }
    } catch (err) {
      setErrorMsg("Error capturing order");
    }
  };

  // FOR PAYPAY 
  // const createOrder = (data: any, actions: any) => {
  //   return actions.order.create({
  //     purchase_units: [
  //       {
  //         reference_id: guestyListingId,
  //         description: 'Booking Payment For ' + listingName,
  //         amount: {
  //           currency_code: paypalCurrency,
  //           value: paypalTotalPrice
  //         },
  //       },
  //     ],
  //     application_context: {
  //       shipping_preference: 'NO_SHIPPING'
  //     }
  //   })
  //     .then((orderID: any) => {
  //       setOrderId(orderID);
  //       console.log(orderID);
  //       return orderID
  //     })
  // }
  const onApprove = (data: any, actions: any) => {
    return actions.order.capture().then(function (details: any) {
      const { payer } = details
      //console.log(details);
      //console.log(actions);
      setSuccess(true);
      var BookingRerence_Number = randomString(10);
      axios.post(process.env.REACT_APP_BASE_URL + "paypal_booking_v1", {
        items: [{
          amount: paypalTotalPrice,
          cart_ids: cartIDS,
          bookingRefNo: BookingRerence_Number,
          user_id: user?.user_id,
          bookingSource: bookingSource,
          payment_details: details,
          discount_code: (appliedCode != null ? appliedCode : '')
        }]
      })
        .then(function (response) {
          if (response.data.success) {
            history.push("pay-done/" + response.data.booking_ref_no);
          }
        });
    })
  }
  const onError = (data?: any, actions?: any) => {
    setErrorMessage("An error occured with your payment")
  };
  function closeModalCoupon() {
    setIsOpenModalCoupon(false);
  }
  function openModalCoupon() {
    setIsOpenModalCoupon(true);
  };
  const handleChangePaymentOptions = (paymentMethod: string) => {
    //setPaymentMethod(e.target.value);
    //console.log("Selected Payment Method:", paymentMethod); // ✅ Debugging
    setPaymentMethod(paymentMethod);
  };
  const validateCouponInput = () => {
    const fields = [
      {
        name: 'name',
        value: detailsCoupon.coupon_code,
        message: 'Code should not be blank.'
      }
    ];
    const isNotFilled = fields.some(field => {
      if (field.value.trim() === '') {
        setErrorMsg(field.message);
        //field.name === 'email' ? emailRef.current.focus() : passwordRef.current.focus();
        return true;
      }
      setErrorMsg('');
      return false;
    });
    return isNotFilled;
  };
  const submitHandlerCoupon = () => {
    const isInvalid = validateCouponInput();
    if (!isInvalid) {
      axios.post(process.env.REACT_APP_BASE_URL + 'getCoupon_v1', {
        detailsCoupon,
        user_id: user?.user_id,
        cart_id: cartIDS
      })
        .then(function (response) {
          if (response.data.status === 200) {
            const newCoupon = response.data.coupon_data; // ✅ Get coupon from API response

            // ✅ Determine if it's a Promo Code or Gift Card
            if (newCoupon.type === "PROMO CODE") {
              setAppliedCoupon(newCoupon.couponCode);
              localStorage.setItem("appliedCoupon", newCoupon.couponCode);
              // Store manually applied promo codes separately
              const updatedPromoCoupons = [...(JSON.parse(localStorage.getItem("manuallyAppliedPromoCoupons") || "[]")), newCoupon];
              localStorage.setItem("manuallyAppliedPromoCoupons", JSON.stringify(updatedPromoCoupons));
              setActiveTab("discount");
            } else if (newCoupon.type === "GIFT CODE") {
              setAppliedGift(newCoupon.couponCode);
              localStorage.setItem("appliedGift", newCoupon.couponCode);
              // Store manually applied gift cards separately
              const updatedGiftCoupons = [...(JSON.parse(localStorage.getItem("manuallyAppliedGiftCoupons") || "[]")), newCoupon];
              localStorage.setItem("manuallyAppliedGiftCoupons", JSON.stringify(updatedGiftCoupons));
              setActiveTab("gift");
            }

            setDetailsCoupon({ coupon_code: "" });
            setSuccessMsg(response.data.response);
          } else {
            setErrorMsg(response.data.response);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setSuccessMsg('');
    }
  };

  // ✅ useEffect to fetch & merge coupons correctly
  useEffect(() => {
    // ✅ Get stored manually applied promo codes & gift cards separately
    const savedPromoCoupons: CouponDataTaxonomy[] = JSON.parse(localStorage.getItem("manuallyAppliedPromoCoupons") || "[]");
    const savedGiftCoupons: CouponDataTaxonomy[] = JSON.parse(localStorage.getItem("manuallyAppliedGiftCoupons") || "[]");

    const savedAppliedCoupon: string | null = localStorage.getItem("appliedCoupon");
    const savedAppliedGift: string | null = localStorage.getItem("appliedGift");

    axios
      .get<{
        coupon_data: CouponDataTaxonomy[];
        totalpromoCount: number;
        totalGiftCount: number;
      }>(
        process.env.REACT_APP_BASE_URL + "getMywalletCoupons",
        { params: { user_id: user?.user_id, activeTab } } // ✅ Fetch only for selected tab
      )
      .then((response) => {
        let fetchedCoupons: CouponDataTaxonomy[] = response.data.coupon_data || [];

        let mergedCoupons: CouponDataTaxonomy[] = [];
        if (activeTab === "discount") {
          // ✅ Merge manually applied Promo Codes with fetched Promo Codes
          mergedCoupons = [
            ...savedPromoCoupons.filter(
              (mc) => !fetchedCoupons.some((fc) => fc.couponCode === mc.couponCode)
            ),
            ...fetchedCoupons,
          ];
        } else if (activeTab === "gift") {
          // ✅ Merge manually applied Gift Cards with fetched Gift Cards
          mergedCoupons = [
            ...savedGiftCoupons.filter(
              (mc) => !fetchedCoupons.some((fc) => fc.couponCode === mc.couponCode)
            ),
            ...fetchedCoupons,
          ];
        }

        setCoupons(mergedCoupons);
        setTotalPromoCount(response.data.totalpromoCount);
        setTotalGiftCount(response.data.totalGiftCount);
      })
      .catch((error) => console.log(error));

    // ✅ Restore applied coupon & gift card from localStorage
    if (savedAppliedCoupon) {
      setAppliedCoupon(savedAppliedCoupon);
    }
    if (savedAppliedGift) {
      setAppliedGift(savedAppliedGift);
    }
  }, [activeTab, appliedCoupon, appliedGift]);

  // ✅ Handle applying a coupon
  const handleApplyCoupon = (couponCode: string, type: "PROMO CODE" | "GIFT CODE") => {
    axios.post(process.env.REACT_APP_BASE_URL + "validateCoupon", {
      couponCode,
      type,
      user_id: user?.user_id,
    })
      .then(response => {
        if (response.data.status === 200) {
          // ✅ If valid, apply the coupon
          if (type === "PROMO CODE") {
            setAppliedCoupon(couponCode);
            localStorage.setItem("appliedCoupon", couponCode);
          } else {
            setAppliedGift(couponCode);
            localStorage.setItem("appliedGift", couponCode);
          }
        } else {
          // ❌ If invalid, remove the coupon
          setAppliedCouponError("Something went wrong. Please try again.");
          //removeInvalidCoupon(type);
        }
      })
      .catch(error => {
        console.error("Error validating coupon:", error);
        setAppliedCouponError("Something went wrong. Please try again.");
      });

    if (type === "PROMO CODE") {
      setAppliedCoupon(couponCode);
      localStorage.setItem("appliedCoupon", couponCode);
    } else {
      setAppliedGift(couponCode);
      localStorage.setItem("appliedGift", couponCode);
    }
  };

  useEffect(() => {
    const savedAppliedCoupon = localStorage.getItem("appliedCoupon");
    const savedAppliedGift = localStorage.getItem("appliedGift");

    if (savedAppliedCoupon) {
      handleApplyCoupon(savedAppliedCoupon, "PROMO CODE"); // ✅ Auto-validate promo coupon
    }
    if (savedAppliedGift) {
      handleApplyCoupon(savedAppliedGift, "GIFT CODE"); // ✅ Auto-validate gift card
    }
  }, [cartIDS, grandTotalAmtDisplay]); // ✅ Runs when cart changes
  const removeInvalidCoupon = (type: "PROMO CODE" | "GIFT CODE") => {
    if (type === "PROMO CODE") {
      setAppliedCoupon(null);
      localStorage.removeItem("appliedCoupon");
    } else {
      setAppliedGift(null);
      localStorage.removeItem("appliedGift");
    }
  };
  const handleRemoveCode = () => {
    if (activeTab === "discount") {
      if (appliedCoupon) {
        // ✅ Remove from applied state
        setAppliedCoupon(null);
        localStorage.removeItem("appliedCoupon");

        // ✅ Remove from manually applied promo coupons
        const updatedPromoCoupons = JSON.parse(localStorage.getItem("manuallyAppliedPromoCoupons") || "[]")
          .filter((coupon: CouponDataTaxonomy) => coupon.couponCode !== appliedCoupon);

        localStorage.setItem("manuallyAppliedPromoCoupons", JSON.stringify(updatedPromoCoupons));

        // ✅ Update coupons state to reflect removal
        setCoupons((prevCoupons) => prevCoupons.filter((coupon) => coupon.couponCode !== appliedCoupon));
      }
    } else {
      if (appliedGift) {
        // ✅ Remove from applied state
        setAppliedGift(null);
        localStorage.removeItem("appliedGift");

        // ✅ Remove from manually applied gift coupons
        const updatedGiftCoupons = JSON.parse(localStorage.getItem("manuallyAppliedGiftCoupons") || "[]")
          .filter((coupon: CouponDataTaxonomy) => coupon.couponCode !== appliedGift);

        localStorage.setItem("manuallyAppliedGiftCoupons", JSON.stringify(updatedGiftCoupons));

        // ✅ Update coupons state to reflect removal
        setCoupons((prevCoupons) => prevCoupons.filter((coupon) => coupon.couponCode !== appliedGift));
      }
    }
  };
  const renderGrandTotalSection = () => {
    return (
      <div className="w-full flex flex-col w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 
    space-y-6 sm:space-y-4 px-0 sm:p-4 xl:p-4 pedding-5">
       <h4>BOOKING SUMMARY</h4>
        <div className="price-details">
          <table>
            <tbody>
              <tr>
                <td className="text-left font-size-15 ">TOTAL NIGHTS PRICE</td>
                <td className="text-right font-size-15">{grandTotalAmtDisplay.price_prefix}  {grandTotalAmtDisplay.subtotal}</td>
              </tr>
              {Number(grandTotalAmtDisplay.display_additonal_guest_price) > 0 &&
                <tr>
                  <td className="text-left font-size-15 ">TOTAL ADDITIONAL GUESTS</td>
                  <td className="text-right font-size-15">{grandTotalAmtDisplay.price_prefix}  {grandTotalAmtDisplay.display_additonal_guest_price}</td>
                </tr>
              }
              {appliedCoupon != null &&
                <tr>
                  <td className="text-left font-size-15 ">PROMO CODE - {appliedCoupon}</td>
                  <td className="text-right font-size-15">— {grandTotalAmtDisplay.price_prefix} {grandTotalAmtDisplay.discountamout}</td>
                </tr>
              }
              <tr>
                <td className="text-left font-size-15 ">TOTAL CLEANING FEE</td>
                <td className="text-right font-size-15">{grandTotalAmtDisplay.price_prefix}  {grandTotalAmtDisplay.totalCleaning}</td>
              </tr>
              <tr>
                <td className="text-left font-size-15 ">TOTAL TINY SERVICE FEE	({grandTotalAmtDisplay.service_fee_percentage})</td>
                <td className="text-right font-size-15">{grandTotalAmtDisplay.price_prefix} {grandTotalAmtDisplay.totalService}</td>
              </tr>
              {grandTotalAmtDisplay.totalTaxes!=="0.00" && 
                <tr>
                  <td className="text-left font-size-15 ">TOTAL TAXES	({grandTotalAmtDisplay.tax_rate_percentage})</td>
                  <td className="text-right font-size-15">{grandTotalAmtDisplay.price_prefix} {grandTotalAmtDisplay.totalTaxes}</td>
                </tr>
              }
              
              {grandTotalAmtDisplay.giftcardAmount !== "0.00" &&
                <tr>
                  <td className="text-left font-size-15 ">GIFT CODE - {appliedGift}</td>
                  <td className="text-right font-size-15">— {grandTotalAmtDisplay.price_prefix}  {grandTotalAmtDisplay.giftcardAmount}</td>
                </tr>
              }
              <tr>
                <th className="text-left font-size-15 "> GRAND TOTAL</th>
                <th className="text-right font-size-15">{grandTotalAmtDisplay.price_prefix} {grandTotalAmtDisplay.displayGrandTototal}</th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
  const renderPromocodeSection = () => {
    return (
      <div className="card-procode mb-4">
        <h2>ADD PROMO CODE</h2>
        <div className="group-type-btn mt-15">
          <Input type="text"
            placeholder="Enter Gift Card Voucher code or Promo Code"
            className="group-input"
            name="coupon_code"
            id="coupon_code"
            onChange={event => {
              setDetailsCoupon({ ...detailsCoupon, coupon_code: event.target.value });
              setErrorMsg("");  // ✅ Clear error message on key press  
            }
            }
            ref={CouponRef}
            autoComplete="off"
            autoFocus={showPopover}
            value={detailsCoupon.coupon_code} />
          <button className="" onClick={submitHandlerCoupon}>APPLY</button>
        </div>
        {errorMsg && <p className="text-red-500 mt-2">{errorMsg}</p>}
        <div className="flex flex-border-btn felx-box-css">
          <ButtonPrimary onClick={() => setActiveTab("gift")} className={activeTab === "gift" ? "" : "inactive"}>Available Gift Card ({totalGiftCount})</ButtonPrimary>
          <ButtonPrimary onClick={() => setActiveTab("discount")} className={activeTab === "discount" ? "" : "inactive"}>Available Promo Code ({totalPromoCount})</ButtonPrimary>
        </div>
        <div className="border-b border-neutral-200 dark:border-neutral-700 p-0 mt-3"></div>
        <SectionCouponSlider
          categories={coupons}
          appliedCoupon={activeTab === "discount" ? appliedCoupon : appliedGift}
          onApplyCoupon={(couponCode, type) => handleApplyCoupon(couponCode, type)}
          appliedCouponError={appliedCouponError}
          onRemoveCoupon={handleRemoveCode}
        />
      </div>
    )
  }
  const renderBookingNotes = () => {
    return (
      <div className="cart-page-list-page">
        <h4>BOOK WITH CONFIDENCE AT TINY AWAY</h4>
        <ul className="card-list-ul-checkout">
          <li><i className="las la-check-circle mr-2"></i>WE USE A SECURE PAYMENT NETWORK </li>
          <li><i className="las la-check-circle mr-2"></i>YOUR DATA IS ALWAYS PROTECTED </li>
          <li><i className="las la-check-circle mr-2"></i>WE PROVIDE REAL HUMAN-TO-HUMAN SUPPORT</li>
        </ul>
      </div>
    );
  }
  const renderCartListingDetailsSection = (cartItems: any) => {
    return (
      <div className="flex flex-direction-column justify-between">
        <div className="flex">
          <div className="py-0  px-0 space-y-0 w-5/6">
            <div>
              <h5 className="uppercase text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1 font-bold">
                {cartItems.listing_name}
              </h5>
              <p className="uppercase">{cartItems.address} </p>
            </div>
            <div className="flex flex-direction-column gap-1 mb-1">
              <div className="flex gap-2 mb-1">
                <i className="las la-calendar-alt font-size-20"></i>
                <span className="uppercase block  text-sm text-neutral-500 dark:text-neutral-400 mb-0">
                  {cartItems.check_checkout_date_html}
                </span>
              </div>
              <div className="flex gap-2 mb-1">
                <i className="las la-user-friends font-size-20"></i>
                <span className="uppercase block  text-sm text-neutral-500 dark:text-neutral-400 mb-0">
                  {cartItems.totalGuest} PEOPLE
                </span>
              </div>
              <div className="flex gap-2 mb-1">
                <i className="las la-bed font-size-20"></i>
                <span className="uppercase block  text-sm text-neutral-500 dark:text-neutral-400 mb-0">
                  {cartItems.beds} beds
                </span>
              </div>
              <div className="flex gap-2 mb-1">
                <i className="las la-bath font-size-20"></i>
                <span className="uppercase block  text-sm text-neutral-500 dark:text-neutral-400 mb-0">
                  {cartItems.bathrooms} baths
                </span>
              </div>
            </div>
          </div>
          <div>
            <span className="edit-class"><a href={cartItems.href}><i className="las la-edit"></i> Edit</a></span>
            <div className="flex-shrink-0 w-full sm:w-40  relative">
              <div className=" w-checkout-page-sm-img  overflow-hidden mb-2">
                <NcImage src={cartItems.listing_image} />
                <button onClick={(e) => DeleteCart(cartItems.id)} className="btn--delete-cart  rounded-full focus:outline-none text-neutral-6000 dark:text-neutral-400">
                  X
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  const renderCartPricingDetailsSection = (cartItems: any) => {
    return (
      <div className="show-hide-payment-form-payment mb-0">
        <h4>PRICE DETAILS</h4>
        <div className="mt-15 price-details mb-0">
          <table>
            <tbody>
              <tr>
                <td>{cartItems.line_price.display_price_per_night}</td>
                <td className="text-right">{cartItems.line_price.display_price_per_night_total}</td>
              </tr>
              {cartItems.line_price.additional_guests > 0 &&
                <tr>
                  <td>ADDITIONAL GUESTS — {cartItems.line_price.additional_guests} {cartItems.line_price.display_additional_guest_price}</td>
                  <td className="text-right">{cartItems.line_price.display_additional_guests_price}</td>
                </tr>
              }
              <tr>
                <td>CLEANING FEE</td>
                <td className="text-right">{cartItems.line_price.display_cleaning_fee}</td>
              </tr>
              <tr>
                <td>TINY SERVICE FEE ({cartItems.line_price.services_fee_perc})</td>
                <td className="text-right">{cartItems.line_price.display_service_fee}</td>
              </tr>
              {cartItems.line_price.display_taxes_fee!=="0.00" && 
                <tr>
                <td>TAXES ({cartItems.line_price.taxes_percent})</td>
                <td className="text-right">{cartItems.line_price.display_taxes_fee}</td>
              </tr>
              }
              
              <tr>
                <th className="text-left">TOTAL</th>
                <th className="text-right">{cartItems.line_price.display_line_item_total_price}</th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
  const renderEmptyCartPageSection = () => {
    return (
      <div className="show-bfr-error">
        <div className="epty-card-text">
          <NcImage src="https://pictures.tinyaway.com/filters:format(svg)/icons/TA_UIUX_Error.svg" />
          <h1>Your cart is empty. </h1>
          <p>Start exploring Tiny House locations and plan your next adventure today!</p>
          <a href="/book-a-tiny-house">
            <ButtonPrimary>Find Your Next Adventure</ButtonPrimary>
          </a>
        </div>
      </div>
    )
  }
  const renderSidebarCartDetails = () => {
    return (
      <div className="flex flex-direction-column gap-4">
        <div className=" ">
          <div className="p-0">
            {cartDetails && cartDetails.length != 0 ?
              <div>
                {cartDetails.map((cartItems: any) => (
                  <div key={cartItems.id} className={` pedding-5 w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 
    space-y-6 sm:space-y-4 px-0 sm:p-4 xl:p-4 p-4 ${cartItems.remove_cart_class}`}>
                    {renderCartListingDetailsSection(cartItems)}
                    <div className="border-b border-neutral-200 dark:border-neutral-700 p-0 mt-2"></div>
                    {renderCartPricingDetailsSection(cartItems)}
                    <div className="text-center">{cartItems.message}</div>
                  </div>
                ))}


                {renderBookingNotes()}
              </div>
              :
              <>
                {renderEmptyCartPageSection()}
              </>

            }
          </div>
        </div>
      </div>
    );
  };
  const removeDiscount = () => {
    if (searchParams.has('coupon_code')) {
      searchParams.delete('coupon_code')
      history.replace({
        search: searchParams.toString(),
      })
    }
    setIsDicountApplied(false);
    history.go(0);
  }
  const renderXClear = () => {
    return (
      <span onClick={() => removeDiscount()} className="w-4 h-4 rounded-full bg-primary-500 text-white flex items-center justify-center ml-3 cursor-pointer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    );
  };
  const renderGiftCardsIcon = () => {
    return (
      <span className="theme-color-bg"> <i className="la la-gift" aria-hidden="true"></i></span>
    );
  };
  const renderCouponIcon = () => {
    return (
      <span className="theme-color-bg">  <svg className="mr-2 w-5" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88">
        <path d="M13.7,49.54,8,33.63a3.47,3.47,0,0,1,2.1-4.44,3.93,3.93,0,0,1,.81-.18L27.3,27.3,29,10.79a3.47,3.47,0,0,1,3.81-3.1,2.9,2.9,0,0,1,.71.15l16,4.11L58.8,1.21A3.49,3.49,0,0,1,63.7.83a3.91,3.91,0,0,1,.61.68l9,12.17,15.91-5.8A3.48,3.48,0,0,1,93.69,10a3.44,3.44,0,0,1,.19.83l1.7,16.51L112.09,29a3.47,3.47,0,0,1,2.71,5.09l-7.3,13.77,14,10.83a3.46,3.46,0,0,1,.62,4.87,3.18,3.18,0,0,1-.72.7L109.2,73.33,115,89.24a3.48,3.48,0,0,1-2.08,4.45,3.44,3.44,0,0,1-.83.19l-16.51,1.7L93.88,112a3.48,3.48,0,0,1-3.81,3.1,3.61,3.61,0,0,1-1.27-.38L75,107.49l-10.85,14a3.46,3.46,0,0,1-5.57-.1l-9.08-12.25-15.91,5.74A3.47,3.47,0,0,1,29,112.05L27.3,97.29,10.53,93.82a3.46,3.46,0,0,1-2.7-4.09A2.62,2.62,0,0,1,8,89.11L13.7,73.34,1.4,64.23a3.48,3.48,0,0,1-.72-4.86,3.42,3.42,0,0,1,.77-.75L13.7,49.54Zm62.39-6.2L55.66,78.86a6.86,6.86,0,0,1-.67,1,2.76,2.76,0,0,1-.82.71,3.14,3.14,0,0,1-1.1.31,10.25,10.25,0,0,1-1.31.07H47.9a1.16,1.16,0,0,1-1.16-1.15,1.18,1.18,0,0,1,.21-.67L67.39,43.57a7.2,7.2,0,0,1,.65-1l0-.06a2.84,2.84,0,0,1,.78-.65A3.15,3.15,0,0,1,70,41.59h0a10,10,0,0,1,1.29-.07h3.85a1.16,1.16,0,0,1,1.16,1.15,1.18,1.18,0,0,1-.21.67Zm-7.4,36.07c-1.72-1.8-2.59-4.56-2.59-8.28s.87-6.48,2.59-8.28,4.52-2.7,8.4-2.7,6.68.9,8.4,2.7,2.58,4.56,2.58,8.28-.86,6.48-2.58,8.28-4.52,2.7-8.4,2.7-6.68-.9-8.4-2.7Zm6-11.44v8h1.3a16.21,16.21,0,0,0,3.27-.26c.22-.18.33-.67.33-1.46v-8h-3a3,3,0,0,0-1.58.26c-.21.18-.32.67-.32,1.46ZM37.39,60q-2.58-2.7-2.58-8.28t2.58-8.28q2.58-2.7,8.4-2.7t8.4,2.7q2.58,2.7,2.58,8.28T54.19,60q-2.58,2.7-8.4,2.7T37.39,60Zm6-11.44v8h3a2.93,2.93,0,0,0,1.57-.27c.22-.18.33-.67.33-1.46v-8H46.93a15.28,15.28,0,0,0-3.26.27c-.22.17-.33.66-.33,1.45ZM16,35.46l5,14a3.48,3.48,0,0,1-1.14,4.13L9.3,61.44,19.9,69.3a3.48,3.48,0,0,1,1.2,4L15.84,87.84,31,91a3.48,3.48,0,0,1,3,3.05l1.49,12.9,14.05-5.06A3.47,3.47,0,0,1,53.59,103l7.91,10.68,9.74-12.61A3.48,3.48,0,0,1,75.69,100l11.81,6.21L89,92.1A3.47,3.47,0,0,1,92.06,89L107,87.43,101.8,73.32a3.46,3.46,0,0,1,1.18-4l10.67-7.92-12.52-9.67A3.5,3.5,0,0,1,100,47.18l6.26-11.8L92.1,33.93A3.48,3.48,0,0,1,89,30.82L87.43,15.93,73.32,21.08a3.48,3.48,0,0,1-4-1.18L61.24,9l-7.8,9.07a3.48,3.48,0,0,1-3.5,1.1L35.5,15.5,33.92,30.78a3.47,3.47,0,0,1-3.1,3.14L16,35.46Z" />
      </svg>
      </span>
    );
  }
  const directbooking = () => {
    var BookingRerence_Number = randomString(10);
    setProcessing(true);
    setDisabled(true);
    axios.post(process.env.REACT_APP_BASE_URL + "direct_booking_v1", {
      items: [{
        amount: paypalTotalPrice,
        cart_ids: cartIDS,
        bookingRefNo: BookingRerence_Number,
        user_id: user?.user_id,
        bookingSource: bookingSource,
        discount_code: (appliedCoupon != null ? appliedCoupon : ''),
        giftcard_code: (appliedGift != null ? appliedGift : ''),
        guest_message:paymentmessage
      }]
    })
      .then(function (response) {
        if (response.data.success) {
          localStorage.removeItem("appliedCoupon");
          localStorage.removeItem("manuallyAppliedPromoCoupons");
          localStorage.removeItem("appliedGift");
          localStorage.removeItem("manuallyAppliedGiftCoupons");
          history.push(`/pay-done/${response.data.booking_ref_no}`);
          history.go(0);
        }
      });
  }
  const submitPhoneHandler = () => {
    const isPhoneValid = isValidPhoneNumber(value);
  
    if (!isPhoneValid) {
      setErrorMsg("Please input correct phone number");
      return;
    }
  
    details.phone = value;
    axios
      .post(`${process.env.REACT_APP_BASE_URL}update_guest_details?user_id=${user?.user_id}`, details)
      .then((response) => {
        if (response.data.status === 200) {
          setSuccessMsg("Phone updated successfully");
          setDetails({ ...details, phone: "" });
          setPhoneMandatory(false);
          setErrorMsg("");
          window.location.reload();
        } else {
          setErrorMsg(response.data.response);
        }
      })
      .catch(console.error);
  };
  const submitEmailHandler = () => {
    if (details.email.trim() === "") {
      setErrorMsg("Email should not be blank.");
      return;
    }
  
    axios
      .post(`${process.env.REACT_APP_BASE_URL}update_guest_details?user_id=${user?.user_id}`, details)
      .then((response) => {
        if (response.data.status === 200) {
          setSuccessMsg("Email updated successfully");
          setDetails({ ...details, email: "" });
          setEmailMandatory(false);
          setErrorMsg("");
          window.location.reload();
        } else {
          setErrorMsg(response.data.response);
        }
      })
      .catch(console.error);
  };  
  const validateInput = () => {
    const fields = [
      {
        name: 'email',
        value: details.email,
        message: 'Email should not be blank.'
      }
    ];
    const isNotFilled = fields.some(field => {
      if (field.value.trim() === '') {
        setErrorMsg(field.message);
        //field.name === 'email' ? emailRef.current.focus() : passwordRef.current.focus();
        return false;
      }
      setErrorMsg('');
      return true;
    });
    return isNotFilled;
  };
  const renderStripePayment = () => {
    return (
      <>
        {clientSecret && stripePromise && (
          <Elements options={options} stripe={stripePromise}>
            <CheckoutForm
              clientSecret={clientSecret}
              bookingRef={bookingRef}
              grandTotalAmount={paypalTotalPrice}
              appliedDiscountCode={appliedCoupon}
              appliedGiftCardCode={appliedGift}
              cartIds={Array.isArray(cartIDS) ? cartIDS.join(",") : cartIDS}  // ✅ Convert array to string
              onPaymentSuccess={handlePaymentSuccess}
              paymentmessage={paymentmessage}
              countryID={listingCountry}
              setIsButtonDisabled={setIsButtonDisabled} 
              setIsButtonProccessing={setIsButtonProccessing} 
              setIsButtonSucceed={setIsButtonSucceed} 
              ref={checkOutFormRef} 
              setErrorMessage={setPaymentError}  // ✅ Receiving error messages
            />
          </Elements>
        )}
      </>
    )
  }
  useEffect(() => {
    if (phoneMandatory || emailMandatory) {
      setErrorMsg("Please enter your phone number and email before proceeding.");
    } else {
      setErrorMsg(""); // Clear error when both are entered
    }
  }, [phoneMandatory, emailMandatory]); // Runs when these values change
  const renderPaypalButton = () => {
    if (phoneMandatory || emailMandatory) {
      return null; // Do not render PayPal button if details are missing
    }
    return (
      <PayPalScriptProvider
        options={{
          "client-id": paypalClientid,
          currency: paypalCurrency,
          intent: "capture",
        }}
      >
        <ButtonPrimary onClick={createOrder} >
            COMPLETE BOOKING
          </ButtonPrimary>
          {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}
      </PayPalScriptProvider>
    )
  }
  const renderDirectBillButton = () => {
    if (phoneMandatory || emailMandatory) {
      return null; // Do not render PayPal button if details are missing
    }
    return (
      <ButtonPrimary disabled={processing || disabled} onClick={directbooking} type="button">
        <span id="button-text">
          {processing ? (
            <div className="las la-spinner" id="spinner"></div>
          ) : (
            "COMPLETE BOOKING"
          )}
        </span>
      </ButtonPrimary>
    )
  }
  const renderStripeButton = () =>{
    return(
      <ButtonPrimary type="submit" disabled={isButtonDisabled} id="submit" onClick={handleCompleteBooking}>
        {isButtonProccessing ? <span>Processing...</span> : "COMPLETE BOOKING"}
      </ButtonPrimary>
    )
  }
  const renderGuestEmailPhoneUpdates = () =>{
    return(
      <div className="mt-2">
          <h3 className="font-semibold text-lg">Required for your trip</h3>
          {phoneMandatory && 
            <>
            <div className="flex mt-2">
            <PhoneInput
              placeholder="Enter phone number"
              international
              value={details.phone}
              defaultCountry="AU"
              countryCallingCodeEditable={false}
              onChange={(val) => {
                setValue(val); // Update the phone number
                setErrorMsg(""); // Clear error when user types
              }}
              onKeyUp={() => setErrorMsg("")} // Clear error on keyup
              phoneDigits={8}
              error={value ? (isValidPhoneNumber(value) ? undefined : 'Invalid phone number') : 'Phone number required'}
            />
              <ButtonPrimary className="rounded-md ml-1" type="button" onClick={submitPhoneHandler}>
                Add
              </ButtonPrimary>
            </div>
            <p className="text-gray-500 text-sm mt-1">Add and confirm your phone number to get trip updates.</p>
            </>
          }
          
          {emailMandatory && 
          <>
          <div className="flex mt-2">
          <Input
              type="email"
              placeholder="Please enter your email"
              className="rounded mt-1"
              name="email"
              id="email"
              onChange={(event) => {
                setDetails({ ...details, email: event.target.value });
                setErrorMsg(""); // Clear error when typing
              }}
              onKeyUp={() => setErrorMsg("")} // Clear error on keyup
              ref={emailRef}
              autoComplete="off"
              autoFocus={showPopover}
              value={details.email}
            />
            <ButtonPrimary className="rounded-md ml-1" type="button"  onClick={submitEmailHandler}>
              Add
            </ButtonPrimary>
          </div>
          <p className="text-gray-500 text-sm mt-1">Add and confirm your email to get trip updates.</p>
          </>
          }
          {successMsg &&
            <div className="text-green-600 mt-2">
              {successMsg}
            </div>}
          {errorMsg &&
           <div className="text-red-600 mt-2">
              {errorMsg}
            </div>
          }
        </div>
    )
  }
  const renderAddMoreHousesSection = () => {
    return (
      <a href="/book-a-tiny-house" className="ml-3 text-blue-600">ADD MORE HOUSE</a>
    )
  }
  const renderPaymentSection = () => {
    return (
        <div className="w-full flex flex-col sm:rounded-2xl padding-box-0">
          {!isCartProceed &&
            <div className="alert alert-danger" role="alert">  <span className="las la-exclamation-circle"></span>These dates are no longer available.</div>
          }
          <div className="pay-with-main">
            <div className="group-box">
             
              {renderGrandTotalSection()}
              <CommonPaymentFields paymentMessage={paymentmessage} setPaymentMessage={setPaymentmessage} cancellationPolicyText={cancellationPolicyText}
                  />
                <div className="border p-4 rounded-lg shadow">
                  
                  <div  className="flex justify-between between-mt-0">
                  <h2 className="font-semibold text-lg mb-2 mt-0">Pay with</h2>
                  <div className="flex justify-end w-2/3 max-width-icon">
                    <img src="https://img.icons8.com/color/48/000000/visa.png" alt="Visa" height="20" />
                    <img src="https://img.icons8.com/color/48/000000/mastercard.png" alt="Mastercard" height="20" />
                    <img src="https://img.icons8.com/color/48/000000/amex.png" alt="American Express" height="20" />
                    <img src="https://img.icons8.com/color/48/000000/paypal.png" alt="PayPal" height="20" />
                    <img src="https://img.icons8.com/color/48/000000/google-pay-india.png" alt="Google Pay" height="20" />
                  </div>
                  </div>
                 
                  {console.log("TESTING"+paymentMethod)}
                  <PaymentDropdown  allowedMethods={availablePaymentMethod} amount={grandTotalAmt} onSelectPayment={handleChangePaymentOptions} />
                    {paymentMethod == 'STRIPE' ? renderStripePayment() :""}
                    {guestDetailsRequired && renderGuestEmailPhoneUpdates()}
                    {paymentError && <div className="text-red-600 mt-2">{paymentError}</div>}
                    {isButtonSucceed && <div className="text-green-600 mt-2">Payment succeeded!</div>}
                    <div className="payment-form-checkout mt-2 mb-1">
                      {paymentMethod == 'PAYPAL' ? renderPaypalButton() : ""}
                      {!isMerchantsAllow ? renderDirectBillButton(): ""}
                      {paymentMethod == 'STRIPE' ? renderStripeButton() :""}
                      {renderAddMoreHousesSection()}
                    </div>
                  <p><i className="text-lg las la-info-circle"></i> Add Multiple Bookings, the dates selected should be the same as the other bookings in the cart</p>
                </div>
            </div>
          </div>
        </div>
    );
  };

  const renderskeletonLoader = () => {
    return (
      <div>
        <div className="custom-loader lg:flex-row gap-3 flex">
          <div className="w-70-loader  lg:w-3/5 xl:w-2/3 border-neutral-200  sm:rounded-2xl sm:border">
            <div className="card m-2">
              <div className="card-body">
                <div className="row mb-5">
                  <div className="col-12">
                    <div className="p-3 bg-grey skeleton"></div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-3">
                    <div className="p-2 bg-grey skeleton"></div>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-6">
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                  </div>
                  <div className="col-6">
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <div className="p-2 bg-grey mb-3 skeleton"></div>
                  </div>
                </div>
                <div className="row mb-5">
                  <div className="col-4">
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                  </div>
                  <div className="col-2">
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                  </div>
                </div>
                <div className="row mb-4 justify-content-between">
                  <div className="col-3">
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                  </div>
                  <div className="col-3">
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <div className="p-2 bg-grey mb-3 skeleton"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-30-loader hidden lg:block flex-grow border-neutral-200 sm:rounded-2xl sm:border">
            <div className="card m-2">
              <div className="card-body">
                <div className="row mb-4">
                  <div className="col-5">
                    <div className="p-5 bg-grey skeleton"></div>
                    <div className="p-2 bg-grey skeleton"></div>
                  </div>
                  <div className="col-7">
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                    <div className="p-2 bg-grey mb-4 skeleton"></div>
                    <div className="p-2 bg-grey mb-2 skeleton"></div>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-12">
                    <div className="p-3 bg-grey skeleton"></div>
                  </div>
                </div>
                <div className="mb-4">
                  <div className="row mb-3 justify-content-between">
                    <div className="col-4">
                      <div className="p-2 bg-grey skeleton"></div>
                    </div>
                    <div className="col-3">
                      <div className="p-2 bg-grey skeleton"></div>
                    </div>
                  </div>
                  <div className="row mb-3 justify-content-between">
                    <div className="col-4">
                      <div className="p-2 bg-grey skeleton"></div>
                    </div>
                    <div className="col-3 justify-content-between">
                      <div className="p-2 bg-grey skeleton"></div>
                    </div>
                  </div>
                  <div className="row mb-3 justify-content-between">
                    <div className="col-4">
                      <div className="p-2 bg-grey skeleton"></div>
                    </div>
                    <div className="col-3">
                      <div className="p-2 bg-grey skeleton"></div>
                    </div>
                  </div>
                  <div className="row mb-4 justify-content-between">
                    <div className="col-4">
                      <div className="p-2 bg-grey skeleton"></div>
                    </div>
                    <div className="col-3">
                      <div className="p-2 bg-grey skeleton"></div>
                    </div>
                  </div>
                  <div className="row mb-3 justify-content-between">
                    <div className="col-4">
                      <div className="p-3 bg-grey skeleton"></div>
                    </div>
                    <div className="col-3">
                      <div className="p-3 bg-grey skeleton"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const handleCompleteBooking = () => {
      if (!phoneMandatory && !emailMandatory) {
        checkOutFormRef.current?.submitForm();
      }else{
        if(phoneMandatory){
          setErrorMsg('Please input correct phone number');
        }else{
          setErrorMsg('Please input email');
        }
      }
  };
  return (
    <div className={`nc-CheckOutPage ${className}`} data-nc-id="CheckOutPage">
      <Helmet title="Tiny Away | Checkout"></Helmet>

      <main className="container mt-11 mb-24 lg:mb-32">
        {isdataLoaded ?
          <div className="flex flex-col-phone-cart-full lg:flex-row gap-6 check-out-ui">
            {cartDetails && cartDetails.length != 0 ?
              <>
                <div className=" w-full lg:block flex-grow w-1/2">
                  <h2 className="">COMPLETE YOUR BOOKING</h2>
                  {renderSidebarCartDetails()}
                </div>
                <div className="w-full w-1/2">
                  {isCartProceed ?
                    <>
                      <h4>&nbsp;</h4>
                      {renderPromocodeSection()}
                      {renderPaymentSection()}
                    </>
                    :
                    <div className="h-1/2"><h4>PAYMENT METHOD</h4>
                      <div className="line-bg bg-color-gry border-neutral-200 dark:border-neutral-700 flex flex-col h-full p-4 pedding-5 px-0 sm:border sm:p-4 sm:rounded-2xl sm:space-y-4 space-y-6 w-full xl:p-4">
                        <div className="neutral-text-loader">
                          <h2>Secure Processing</h2>
                          <h3>Looks like your cart has an issue. Please correct it, and the payment will load here.</h3>
                          <div className="name-of-payment-icon">
                            <div>
                              <svg width="800" height="713" viewBox="0 0 800 713" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M738.16 0H61.8395C27.7417 0 0 27.7417 0 61.8395V462.622C0 496.72 27.7417 524.462 61.8395 524.462H312.329C318.813 524.462 324.07 519.205 324.07 512.72C324.07 506.236 318.813 500.978 312.329 500.978H61.8395C40.6904 500.978 23.4834 483.771 23.4834 462.622V61.8395C23.4834 40.6904 40.6904 23.4834 61.8395 23.4834H738.16C759.31 23.4834 776.517 40.6904 776.517 61.8395V462.622C776.517 469.107 781.774 474.364 788.258 474.364C794.743 474.364 800 469.107 800 462.622V61.8395C800 27.7417 772.258 0 738.16 0Z" fill="black" />
                                <path d="M324.853 413.307H99.4129C92.9284 413.307 87.6713 418.564 87.6713 425.049C87.6713 431.533 92.9284 436.79 99.4129 436.79H324.853C331.338 436.79 336.595 431.533 336.595 425.049C336.595 418.564 331.338 413.307 324.853 413.307Z" fill="black" />
                                <path d="M236.399 199.609V149.511C236.399 129.224 219.895 112.72 199.609 112.72H124.462C104.175 112.72 87.6713 129.224 87.6713 149.511V199.609C87.6713 219.895 104.175 236.399 124.462 236.399H199.609C219.895 236.399 236.399 219.895 236.399 199.609ZM111.155 199.609V186.301H124.462C130.946 186.301 136.204 181.044 136.204 174.56C136.204 168.075 130.946 162.818 124.462 162.818H111.155V149.511C111.155 142.173 117.124 136.204 124.462 136.204H150.294V212.916H124.462C117.124 212.916 111.155 206.946 111.155 199.609ZM199.609 212.916H173.777V136.204H199.609C206.946 136.204 212.916 142.173 212.916 149.511V162.818H199.609C193.124 162.818 187.867 168.075 187.867 174.56C187.867 181.044 193.124 186.301 199.609 186.301H212.916V199.609C212.916 206.946 206.946 212.916 199.609 212.916Z" fill="black" />
                                <path d="M87.6713 349.902C87.6713 356.387 92.9284 361.644 99.4129 361.644C105.897 361.644 111.155 356.387 111.155 349.902V324.853C111.155 318.369 105.897 313.112 99.4129 313.112C92.9284 313.112 87.6713 318.369 87.6713 324.853V349.902Z" fill="black" />
                                <path d="M125.245 324.853V349.902C125.245 356.387 130.502 361.644 136.986 361.644C143.471 361.644 148.728 356.387 148.728 349.902V324.853C148.728 318.369 143.471 313.112 136.986 313.112C130.502 313.112 125.245 318.369 125.245 324.853Z" fill="black" />
                                <path d="M162.818 324.853V349.902C162.818 356.387 168.075 361.644 174.56 361.644C181.044 361.644 186.301 356.387 186.301 349.902V324.853C186.301 318.369 181.044 313.112 174.56 313.112C168.075 313.112 162.818 318.369 162.818 324.853Z" fill="black" />
                                <path d="M200.391 324.853V349.902C200.391 356.387 205.648 361.644 212.133 361.644C218.618 361.644 223.875 356.387 223.875 349.902V324.853C223.875 318.369 218.618 313.112 212.133 313.112C205.648 313.112 200.391 318.369 200.391 324.853Z" fill="black" />
                                <path d="M273.973 349.902V324.853C273.973 318.369 268.715 313.112 262.231 313.112C255.746 313.112 250.489 318.369 250.489 324.853V349.902C250.489 356.387 255.746 361.644 262.231 361.644C268.715 361.644 273.973 356.387 273.973 349.902Z" fill="black" />
                                <path d="M311.546 349.902V324.853C311.546 318.369 306.289 313.112 299.804 313.112C293.32 313.112 288.063 318.369 288.063 324.853V349.902C288.063 356.387 293.32 361.644 299.804 361.644C306.289 361.644 311.546 356.387 311.546 349.902Z" fill="black" />
                                <path d="M337.378 313.112C330.893 313.112 325.636 318.369 325.636 324.853V349.902C325.636 356.387 330.893 361.644 337.378 361.644C343.862 361.644 349.119 356.387 349.119 349.902V324.853C349.119 318.369 343.862 313.112 337.378 313.112Z" fill="black" />
                                <path d="M386.693 349.902V324.853C386.693 318.369 381.436 313.112 374.951 313.112C368.466 313.112 363.209 318.369 363.209 324.853V349.902C363.209 356.387 368.466 361.644 374.951 361.644C381.436 361.644 386.693 356.387 386.693 349.902Z" fill="black" />
                                <path d="M650.489 236.399C684.587 236.399 712.329 208.658 712.329 174.56C712.329 140.462 684.587 112.72 650.489 112.72H575.342C541.245 112.72 513.503 140.462 513.503 174.56C513.503 208.658 541.245 236.399 575.342 236.399H650.489ZM536.986 174.56C536.986 153.411 554.193 136.204 575.342 136.204H650.489C671.638 136.204 688.845 153.411 688.845 174.56C688.845 195.709 671.638 212.916 650.489 212.916H575.342C554.193 212.916 536.986 195.709 536.986 174.56Z" fill="black" />
                                <path d="M550.294 313.112C440.229 313.112 350.685 402.655 350.685 512.72C350.685 622.785 440.229 712.329 550.294 712.329C660.359 712.329 749.902 622.785 749.902 512.72C749.902 402.655 660.359 313.112 550.294 313.112ZM550.294 688.845C453.177 688.845 374.168 609.836 374.168 512.72C374.168 415.604 453.177 336.595 550.294 336.595C647.41 336.595 726.419 415.604 726.419 512.72C726.419 609.836 647.41 688.845 550.294 688.845Z" fill="black" />
                                <path d="M654.711 441.796L512.72 583.787L445.876 516.942C441.29 512.357 433.855 512.357 429.271 516.942C424.686 521.528 424.686 528.963 429.271 533.547L504.418 608.693C506.71 610.985 509.716 612.133 512.72 612.133C515.724 612.133 518.73 610.987 521.022 608.693L671.316 458.4C675.901 453.814 675.901 446.38 671.316 441.796C666.732 437.21 659.295 437.21 654.711 441.796Z" fill="black" />
                              </svg>

                            </div>
                            <div className="flex-col-mid">
                              <div><svg width="688" height="184" viewBox="0 0 688 184" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M116.336 8.89221C107.722 2.97016 96.4808 0.00195312 82.6131 0.00195312H28.9249C24.6736 0.00195312 22.3249 2.1281 21.8787 6.37528L0.0684587 143.278C-0.158208 144.622 0.178201 145.852 1.07461 146.97C1.96589 148.091 3.08692 148.648 4.42948 148.648H29.931C34.4038 148.648 36.8623 146.527 37.3136 142.273L43.3526 105.365C43.5731 103.576 44.3597 102.122 45.7023 101.002C47.0438 99.884 48.7218 99.1517 50.7351 98.8173C52.7485 98.485 54.6469 98.3179 56.4397 98.3179C58.2274 98.3179 60.3515 98.4307 62.8162 98.6532C65.2746 98.8768 66.8418 98.9856 67.5136 98.9856C86.7505 98.9856 101.85 93.565 112.813 82.7127C123.771 71.8645 129.256 56.8214 129.256 37.5804C129.256 24.3825 124.946 14.8194 116.336 8.88809V8.89221ZM88.6541 49.9999C87.5321 57.8307 84.6274 62.9732 79.93 65.4348C75.2315 67.8994 68.5208 69.124 59.7977 69.124L48.7238 69.4604L54.4295 33.5558C54.8746 31.0973 56.3279 29.8666 58.7905 29.8666H65.1679C74.1115 29.8666 80.6028 31.1558 84.6295 33.724C88.6541 36.2984 89.9967 41.726 88.6541 49.9999Z" fill="#003087" />
                                <path d="M682.911 0H658.082C655.615 0 654.163 1.23078 653.72 3.6913L631.907 143.281L631.571 143.952C631.571 145.076 632.019 146.133 632.916 147.141C633.806 148.145 634.929 148.649 636.271 148.649H658.419C662.663 148.649 665.013 146.528 665.466 142.275L687.277 5.03385V4.70052C687.275 1.56924 685.816 0.00308306 682.911 0.00308306V0Z" fill="#009CDE" />
                                <path d="M382.931 54.0307C382.931 52.9148 382.482 51.8502 381.592 50.845C380.694 49.8389 379.687 49.3333 378.571 49.3333H352.734C350.268 49.3333 348.256 50.4574 346.693 52.6881L311.125 105.037L296.362 54.7035C295.238 51.1261 292.779 49.3333 288.979 49.3333H263.81C262.689 49.3333 261.682 49.8379 260.793 50.845C259.895 51.8502 259.45 52.9158 259.45 54.0307C259.45 54.482 261.632 61.0779 265.993 73.8286C270.354 86.5815 275.052 100.339 280.086 115.105C285.12 129.868 287.745 137.7 287.971 138.59C269.626 163.646 260.457 177.07 260.457 178.856C260.457 181.767 261.91 183.219 264.819 183.219H290.656C293.117 183.219 295.129 182.104 296.697 179.865L382.263 56.3774C382.707 55.9332 382.931 55.1538 382.931 54.0297V54.0307Z" fill="#003087" />
                                <path d="M623.526 49.3334H598.023C594.889 49.3334 592.994 53.0247 592.322 60.4072C586.499 51.4636 575.88 46.9836 560.442 46.9836C544.335 46.9836 530.632 53.0247 519.337 65.1047C508.039 77.1857 502.393 91.3929 502.393 107.721C502.393 120.922 506.25 131.435 513.967 139.262C521.684 147.096 532.03 151.006 545.009 151.006C551.494 151.006 558.093 149.662 564.804 146.98C571.516 144.295 576.768 140.718 580.577 136.242C580.577 136.467 580.35 137.471 579.906 139.26C579.455 141.052 579.235 142.398 579.235 143.286C579.235 146.87 580.685 148.654 583.598 148.654H606.753C610.997 148.654 613.461 146.533 614.13 142.279L627.889 54.7006C628.11 53.358 627.775 52.1293 626.883 51.0093C625.984 49.8944 624.869 49.3334 623.526 49.3334ZM579.737 115.438C574.033 121.031 567.154 123.827 559.101 123.827C552.611 123.827 547.359 122.04 543.33 118.459C539.301 114.886 537.288 109.964 537.288 103.693C537.288 95.4226 540.085 88.4278 545.679 82.7231C551.264 77.0185 558.206 74.1662 566.483 74.1662C572.741 74.1662 577.943 76.0124 582.085 79.7016C586.22 83.3929 588.295 88.4842 588.295 94.9713C588.294 103.024 585.441 109.848 579.737 115.438Z" fill="#009CDE" />
                                <path d="M242.336 49.3334H216.835C213.698 49.3334 211.801 53.0247 211.129 60.4072C205.089 51.4636 194.462 46.9836 179.251 46.9836C163.144 46.9836 149.441 53.0247 138.145 65.1047C126.847 77.1857 121.201 91.3929 121.201 107.721C121.201 120.922 125.06 131.435 132.778 139.262C140.496 147.096 150.84 151.006 163.816 151.006C170.077 151.006 176.568 149.662 183.278 146.98C189.988 144.295 195.358 140.718 199.384 136.242C198.487 138.925 198.042 141.275 198.042 143.286C198.042 146.87 199.495 148.654 202.404 148.654H225.557C229.804 148.654 232.267 146.533 232.939 142.279L246.696 54.7006C246.917 53.358 246.581 52.1293 245.69 51.0093C244.795 49.8944 243.678 49.3334 242.336 49.3334ZM198.546 115.604C192.841 121.092 185.847 123.827 177.575 123.827C171.084 123.827 165.883 122.04 161.971 118.459C158.054 114.886 156.098 109.964 156.098 103.693C156.098 95.4226 158.893 88.4278 164.488 82.7231C170.077 77.0185 177.012 74.1662 185.292 74.1662C191.552 74.1662 196.754 76.0124 200.896 79.7026C205.031 83.3939 207.103 88.4852 207.103 94.9724C207.103 103.248 204.251 110.129 198.546 115.604Z" fill="#003087" />
                                <path d="M497.526 8.89221C488.912 2.97016 477.673 0.00195312 463.804 0.00195312H410.45C405.974 0.00195312 403.511 2.1281 403.068 6.37528L381.257 143.278C381.03 144.624 381.366 145.853 382.263 146.971C383.15 148.091 384.275 148.648 385.618 148.648H413.132C415.816 148.648 417.605 147.196 418.501 144.287L424.542 105.365C424.764 103.576 425.547 102.122 426.891 101.002C428.233 99.884 429.909 99.1527 431.925 98.8173C433.937 98.485 435.834 98.3179 437.629 98.3179C439.417 98.3179 441.541 98.4307 444.003 98.6532C446.463 98.8768 448.034 98.9856 448.7 98.9856C467.941 98.9856 483.038 93.565 494.001 82.7127C504.963 71.8645 510.443 56.8214 510.443 37.5804C510.445 24.3835 506.136 14.8204 497.526 8.88913V8.89221ZM463.132 64.0922C458.21 67.4471 450.827 69.124 440.986 69.124L430.248 69.4604L435.952 33.5558C436.396 31.0973 437.849 29.8666 440.313 29.8666H446.351C451.272 29.8666 455.186 30.0902 458.099 30.5363C461.003 30.9876 463.804 32.3814 466.488 34.7302C469.173 37.0799 470.514 40.4922 470.514 44.9661C470.514 54.3609 468.051 60.7353 463.132 64.0922Z" fill="#009CDE" />
                              </svg>
                              </div>
                              <div>
                                <svg width="361" height="150" viewBox="0 0 361 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clipPath="url(#clip0_35_11)">
                                    <path d="M360 77.4001C360 51.8001 347.6 31.6001 323.9 31.6001C300.1 31.6001 285.7 51.8001 285.7 77.2001C285.7 107.3 302.7 122.5 327.1 122.5C339 122.5 348 119.8 354.8 116V96.0001C348 99.4001 340.2 101.5 330.3 101.5C320.6 101.5 312 98.1001 310.9 86.3001H359.8C359.8 85.0001 360 79.8001 360 77.4001ZM310.6 67.9001C310.6 56.6001 317.5 51.9001 323.8 51.9001C329.9 51.9001 336.4 56.6001 336.4 67.9001H310.6Z" fill="black" />
                                    <path d="M247.1 31.6001C237.3 31.6001 231 36.2001 227.5 39.4001L226.2 33.2001H204.2V149.8L229.2 144.5L229.3 116.2C232.9 118.8 238.2 122.5 247 122.5C264.9 122.5 281.2 108.1 281.2 76.4001C281.1 47.4001 264.6 31.6001 247.1 31.6001ZM241.1 100.5C235.2 100.5 231.7 98.4001 229.3 95.8001L229.2 58.7001C231.8 55.8001 235.4 53.8001 241.1 53.8001C250.2 53.8001 256.5 64.0001 256.5 77.1001C256.5 90.5001 250.3 100.5 241.1 100.5Z" fill="black" />
                                    <path d="M169.8 25.7L194.9 20.3V0L169.8 5.3V25.7Z" fill="black" />
                                    <path d="M194.9 33.3H169.8V120.8H194.9V33.3Z" fill="black" />
                                    <path d="M142.9 40.7L141.3 33.3H119.7V120.8H144.7V61.5C150.6 53.8 160.6 55.2 163.7 56.3V33.3C160.5 32.1 148.8 29.9 142.9 40.7Z" fill="black" />
                                    <path d="M92.8999 11.6001L68.4999 16.8001L68.3999 96.9001C68.3999 111.7 79.4999 122.6 94.2999 122.6C102.5 122.6 108.5 121.1 111.8 119.3V99.0001C108.6 100.3 92.7999 104.9 92.7999 90.1001V54.6001H111.8V33.3001H92.7999L92.8999 11.6001Z" fill="black" />
                                    <path d="M25.3 58.7001C25.3 54.8001 28.5 53.3001 33.8 53.3001C41.4 53.3001 51 55.6001 58.6 59.7001V36.2001C50.3 32.9001 42.1 31.6001 33.8 31.6001C13.5 31.6001 0 42.2001 0 59.9001C0 87.5001 38 83.1001 38 95.0001C38 99.6001 34 101.1 28.4 101.1C20.1 101.1 9.5 97.7001 1.1 93.1001V116.9C10.4 120.9 19.8 122.6 28.4 122.6C49.2 122.6 63.5 112.3 63.5 94.4001C63.4 64.6001 25.3 69.9001 25.3 58.7001Z" fill="black" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_35_11">
                                      <rect width="360.02" height="149.84" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </>
              :
              <div className=" w-full lg:block flex-grow">{renderEmptyCartPageSection()}</div>
            }
          </div>
          :
          <>{renderskeletonLoader()}</>
        }
      </main>
    </div>
  );
};
export default CheckOutPage;
